<template>
    <Head>
        <title>Рефералы пользователя</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <navigation :user-id="userId"/>
        </template>


        <div class="grid grid-cols-3 m-6 gap-6 items-start">

            <div class="flex flex-col gap-6">
                <form method="post" action="#"
                      class="flex flex-row p-4 gap-4 bg-white rounded items-end"
                      @submit.prevent="updateReference"
                >
                    <span>Код</span>
                    <strong class="flex-grow">{{ result.reference.referenceCode }}</strong>
                    <div class="w-20">
                        <v-input label="Процент" type="number" min="0" max="100" v-model="result.reference.referencePercent" @input="changeReference=true"/>
                    </div>
                    <v-button :disabled="!changeReference">Изменить</v-button>
                </form>

                <div class="flex flex-col gap-4 bg-white rounded p-4" v-if="access('refferals', 'add')">
                    <h3>Добавить реферала</h3>
                    <v-input label="Email" v-model="addEmail" type="email"/>
                    <v-button color="green" type="button" :disabled="addEmail === ''" @click="addReferral">добавить</v-button>
                </div>
            </div>

            <form method="post" action="#"
                  class="col-span-2 grid grid-cols-2 p-4 gap-4 bg-white rounded"
                  @change="changeSettings = true"
                  @submit.prevent="updateSettings"
            >
                <v-input label="Срок вознаграждения (дней)" type="number" v-model="result.settings.timeLimit" :error="errors.timeLimit"/>
                <v-input label="Вознаграждения за регистрацию" type="number" v-model="result.settings.registrationBonus" :error="errors.registrationBonus"/>
                <v-checkbox
                    v-for="type in commissionTypes"
                    :checked="(result.settings.commissionTypes || []).indexOf(type) > -1"
                    @update:checked="updateSettingCommission(type)"
                >{{ type }}</v-checkbox>
                <div class="col-span-full flex flex-row justify-end"
                     v-if="access('referrals', 'update_settings')">
                    <v-button :disabled="!changeSettings">Обновить</v-button>
                </div>
            </form>

            <div class="col-span-full p-4 bg-white rounded">
                <h2 class="text-lg font-bold pb-2">Рефералы</h2>
                <div class="grid grid-cols-10 p-2 gap-2 items-end font-bold sticky left-0 top-0 right-0 bg-white">
                    <strong class="col-span-2">Email</strong>
                    <strong class="text-center">Заморожен</strong>
                    <strong class="text-right">Баланс</strong>
                    <strong class="text-center">Процент</strong>
                    <strong class="col-span-2">Код</strong>
                    <div class="text-center">Создан <span class="text-sm text-gray-700">(UTC)</span></div>
                    <div class="text-center">Обновлен <span class="text-sm text-gray-700">(UTC)</span></div>
                </div>
                <div class="grid grid-cols-10 border-t items-center p-2 gap-2" v-for="ref of result.referrals">
                    <span class="col-span-2">{{ ref.userEmail }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current mx-auto" viewBox="0 0 16 16" :class="{
                                    'text-gray-100': !ref.isFrozen,
                                    'text-blue-500': ref.isFrozen,
                                }">
                            <path d="M8 16a.5.5 0 0 1-.5-.5v-1.293l-.646.647a.5.5 0 0 1-.707-.708L7.5 12.793V8.866l-3.4 1.963-.496 1.85a.5.5 0 1 1-.966-.26l.237-.882-1.12.646a.5.5 0 0 1-.5-.866l1.12-.646-.884-.237a.5.5 0 1 1 .26-.966l1.848.495L7 8 3.6 6.037l-1.85.495a.5.5 0 0 1-.258-.966l.883-.237-1.12-.646a.5.5 0 1 1 .5-.866l1.12.646-.237-.883a.5.5 0 1 1 .966-.258l.495 1.849L7.5 7.134V3.207L6.147 1.854a.5.5 0 1 1 .707-.708l.646.647V.5a.5.5 0 1 1 1 0v1.293l.647-.647a.5.5 0 1 1 .707.708L8.5 3.207v3.927l3.4-1.963.496-1.85a.5.5 0 1 1 .966.26l-.236.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.883.237a.5.5 0 1 1-.26.966l-1.848-.495L9 8l3.4 1.963 1.849-.495a.5.5 0 0 1 .259.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.236.883a.5.5 0 1 1-.966.258l-.495-1.849-3.4-1.963v3.927l1.353 1.353a.5.5 0 0 1-.707.708l-.647-.647V15.5a.5.5 0 0 1-.5.5z"/>
                        </svg>
                    <strong class="text-right">{{ ref.balance }}</strong>
                    <span class="text-center">{{ ref.percent }}%</span>
                    <span class="col-span-2 text-sm">{{ ref.code }}</span>
                    <span class="text-center text-sm">{{ moment(ref.created).utc().format('L LTS') }}</span>
                    <span class="text-center text-sm">{{ moment(ref.updated).utc().format('L LTS') }}</span>
                    <div class="flex flex-row justify-between items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current mx-auto text-red-500" viewBox="0 0 16 16"
                             @click="removeReferral(ref.userId)"
                             v-if="access('referrals', 'delete')">
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                        </svg>
                        <Link class="text-gray-500 hover:text-blue-500 text-center" :href="route('user.referrals', ref.userId)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mx-auto fill-current" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </Link>
                    </div>
                </div>
            </div>

        </div>

<!--        <pre class="text-xs bg-black text-green-300 p-6">{{result}}</pre>-->

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from '@/Components/Navigation/User';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VCheckbox from "@/Components/Checkbox";
import VInputError from "@/Components/InputError";
import moment from "moment";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        Navigation,
        VInput,
        VButton,
        VCheckbox,
        VInputError,
    },
    props: {
        notifications: Object,
        result: Object,
        userId: String,
        commissionTypes: Object,
        errors: Object,
    },
    data () {
        return {
            changeSettings: false,
            changeReference: false,
            addEmail: '',
        }
    },
    methods: {
        moment,
        updateSettings() {
            if(this.changeSettings) {
                this.changeSettings = false;
                const {settings} = this.result
                useForm(settings).put(this.route('user.referrals.settings.update', this.userId));
            }
            return false;
        },
        updateReference() {
            if(this.changeReference) {
                this.changeReference = false;
                const {referencePercent} = this.result.reference;
                const route = this.route('user.referrals.reference.update', this.userId);
                useForm({
                    referencePercent,
                }).put(route);
            }
            return false;
        },
        updateSettingCommission(type) {
            const types = this.result.settings.commissionTypes ||  [];
            const index = types.indexOf(type);
            (index > -1) ? types.splice(index, 1) : types.push(type);
            this.result.settings.commissionTypes = types.length ? types : null;
        },
        addReferral() {
            useForm({
                email: this.addEmail,
                userId: this.userId,
            }).post(this.route('ocp.refferals.add'));
        },
        removeReferral(refId) {
            useForm({
                mainRefUserId: this.userId,
                referralUserId: refId,
            }).post(this.route('ocp.refferals.delete'));
        }
    },
}
</script>
